export class SideMenuAction {
  constructor(
    public id: string,
    public activity: string[],
    public title: string,
    public routerLink: string,
    public icon: string,
    public order: number,
    public toggleSideMenu?: boolean,
    public adminOnly?: boolean,
    public fontSet?: string
  ) {}
}
